import {useAppSelector, useAppDispatch} from "../app/store";
import React from 'react';
import {updateSearch} from "../app/slices/searchSlice.ts";

export default function useSearch(form: string) {

    const searchState = useAppSelector((state) => state.search.searches || {})
    const dispatch = useAppDispatch()

    const updateSearchCallback = React.useCallback((advancedSearch: boolean, search: Record<string, any>) => {
        dispatch(updateSearch({
            form,
            advancedSearch,
            search,
        }))
    }, [dispatch, form])

    return {
        updateSearch: updateSearchCallback,
        ...searchState[form]
    }
}
